import React from 'react'
import styles from './filter-options-control.module.scss'
import FilterIcon_ from 'components/filters/FilterIcon'
/** @type {React.ComponentType<any>} */
const FilterIcon = FilterIcon_
import WithTooltip from 'components/shared/WithTooltip'
import StreamName from 'components/filters/StreamName'
import cn from 'classnames'

export default function FilterOptionsControl({
    panel,
    filter,
    team,
    filterUser,
    showFilterOptions,
    setShowFilterOptions,
    contextStyles,
    showLogo,
    showName,
    showHover,
    disable,
    iconStyles,
    // Icon style props to pass through to FilterIcon
    initialStyles,
    publicIcon,
    treechatIcon,
    hodlockerIcon,
    twetchIcon,
    notiIcon,
    fontIcon,
    privateIcon,
    linksIcon,
    historyIcon,
    peopleIcon,
    // Control whether FilterIcon inserts new panel
    enableFilterIconClick = false,
    showPublic = false,
}) {
    const closeStyles = showFilterOptions ? styles.closeStyles : null
    const panelStyles = panel === 'middle' ? null : styles.rightPanel
    const isSignedIn = gon?.currentUser
    const memeChevronStyles = filter?.meme ? styles.memeChevron : null
    const onHoverStyles = showHover ? styles.onHover : null

    const Control = (
        <div className={styles.flexContainer}>
            {showName && (
                <div className={styles.streamNameContainer}>
                    <StreamName
                        filter={filter}
                        panel={panel}
                        contextStyles={contextStyles}
                        filterUser={filterUser}
                        team={team}
                        showPublic={showPublic}
                    />
                </div>
            )}

            {!disable && isSignedIn && (
                <div className={styles.expandFilterBtnContainer}>
                    <div
                        className={cn(
                            styles.expandFilterBtn,
                            panelStyles,
                            closeStyles,
                            memeChevronStyles,
                        )}
                    >
                        {showFilterOptions ? (
                            <i className="fa fa-angle-up" />
                        ) : (
                            <i className="fa fa-angle-down" />
                        )}
                    </div>
                </div>
            )}
        </div>
    )

    return (
        <div
            className={cn(
                styles.filterOptionsControlComp,
                !disable && styles.pointer,
                onHoverStyles,
            )}
            onClick={() => !disable && isSignedIn && setShowFilterOptions(!showFilterOptions)}
        >
            {showLogo && (
                <div
                    className={styles.filterIconContainer}
                    onClick={enableFilterIconClick ? e => e.stopPropagation() : undefined}
                >
                    <FilterIcon
                        user={filter?.user ? filterUser : gon.currentUser}
                        showNumNoti
                        filter={filter}
                        team={team}
                        panel={panel}
                        type={'control'}
                        showPublic={showPublic}
                        disable={!enableFilterIconClick}
                        insertNewPanel={enableFilterIconClick}
                        contextStyles={cn(styles.searchHeaderIcon, iconStyles)}
                        initialStyles={initialStyles || styles.initialStyles}
                        fontIcon={fontIcon || styles.fontIcon}
                        publicIcon={publicIcon}
                        treechatIcon={treechatIcon}
                        hodlockerIcon={hodlockerIcon}
                        twetchIcon={twetchIcon}
                        notiIcon={notiIcon}
                        privateIcon={privateIcon}
                        linksIcon={linksIcon}
                        historyIcon={historyIcon}
                        peopleIcon={peopleIcon}
                    />
                </div>
            )}
            {isSignedIn ? (
                <WithTooltip
                    disable={disable}
                    tip={'Choose channel.'}
                    contextStyles={styles.withTooltip}
                >
                    {Control}
                </WithTooltip>
            ) : (
                Control
            )}
        </div>
    )
}
